import React, {
  Fragment,
  MouseEventHandler,
  ReactNode,
  useContext,
  useEffect,
} from "react";
import ReactDOM from "react-dom";
import classes from "./ModalGlobal.module.css";
import { Store } from "../../../Store";
import {CloseAllModal} from "../../../utils/CloseAllModal";

import ImageImport from "../../../utils/ImageImports";
import useWindowSize from "../../../customHooks/useWindowSize";

const Backdrop = (props: BackdropProps) => {
  return <div className={classes.backdrop} onClick={props.handleModalClose} />;
};

const ModalOverLay = ({modalClassName = '', ...props}: ModalOverLayProps) => {
  const { closeImg } = ImageImport;
  const {isMobile} = useWindowSize();

  
  const funcCalcSize = () => {
    
    let size = {maxWidth: "700px"} as any;
    if(props.modalSize === "md") {
      size = {maxWidth: "700px"}
    } else if(props.modalSize === "sm") {
      size = {maxWidth: "500px",textAlign:"center"}
    } else if(props.modalSize === "lg") {
      size = { maxWidth: "1392px" }
    } else if (props.modalSize === "full") {
      let offset = '48px';
      if (isMobile) {
        offset = '16px';
      }
      size = {width: `calc(100% - ${offset})`, maxWidth: '100%'};
    }
    return size;
  }

  return (
    <div className={`${classes.modal} ${modalClassName}`}
    style={funcCalcSize()}
    >
      {
        props.isModalHeader && <div className={classes.modalTitle}>
        <div className={props.isTitleCenter ? `${classes.flexGrow1} ${props.titleClassName}` : `${classes.flexGrow2} ${props.titleClassName}`}>
          {props.modaltitle}
          <span className="modal__title_name">
            {" "}
            {props.modaltitlename}{" "}
          </span>{" "}
        </div>
        <span className={classes.close_modal} onClick={props.handleModalClose}>
          <img src={closeImg} className="close-modal-img" alt="" />
        </span>
      </div>
      }
      <div className={classes.content}>{props.children}</div>
    </div>
  );
};

const portalElement = document.getElementById("overlays")!;

const ModalGlobal = ({modalClassName = '', ...props}: ModalGlobalProps) => {
  const storeContext = useContext(Store);
  const { setIsModal,setShowError } = storeContext;

  useEffect(() => {
    document.body.classList.add("noScroll");
    setShowError &&
        setShowError({
          isError: false,
          title: "",
          ErrorType: "danger",
        });
        
        return () => {
          document.body.classList.remove("noScroll");
        }
  }, []);


  return (
    <Fragment>
      {ReactDOM.createPortal(
        <Backdrop
          handleModalClose={() => {        
            setIsModal && setIsModal!({ ...CloseAllModal });
          }}
        />,
        portalElement
      )}
      {ReactDOM.createPortal(
        <ModalOverLay
          modaltitle={props.modaltitle}
		  titleClassName={props.titleClassName}
          modaltitlename={props.modaltitlename}
          isTitleCenter={props.isTitleCenter}
          modalSize={props.modalSize ? props.modalSize : "md" }
          handleModalClose={ props.modalClose ? props.modalClose : (
            () => {        
            setIsModal && setIsModal!({ ...CloseAllModal });
          })}
          modalClassName={modalClassName}
          isModalHeader={props.isModalHeader}
        >
          {props.children}
        </ModalOverLay>,
        portalElement
      )}
    </Fragment>
  );
};

interface BackdropProps {
  handleModalClose: MouseEventHandler<HTMLDivElement> | undefined;
}

interface ModalOverLayProps {
  children: ReactNode;
  handleModalClose: MouseEventHandler<HTMLDivElement> | undefined;
  modaltitle: string;
  titleClassName?: string;
  modaltitlename: string;
  modalSize: string;
  isModalHeader: boolean;
  isTitleCenter: boolean;
  modalClassName?: string;
}
interface ModalGlobalProps {
  children: ReactNode;
  modaltitle: string;
  titleClassName?: string;
  modaltitlename: string;
  modalSize?: string;
  modalClose?: () => void;
  isModalHeader: boolean;
  isTitleCenter: boolean;
  modalClassName?: string;
}

ModalGlobal.defaultProps = {
  modaltitlename: "",
  modalSize: "",
  isTitleCenter:false

};
export default ModalGlobal;
